/**
 * "Just logged out" flag shared across providers.
 *
 * sessionStorage (not localStorage): a fresh tab or new visit starts clean and
 * auto-logs-in as before. The logged-out landing only appears immediately after
 * an explicit logout in the same tab session, which is what stops RequireAuth's
 * auto-relogin loop.
 */
export const LOGGED_OUT_KEY = 'lens_logged_out'

export const setLoggedOut = () => sessionStorage.setItem(LOGGED_OUT_KEY, '1')
export const isLoggedOut = () => sessionStorage.getItem(LOGGED_OUT_KEY) === '1'
export const clearLoggedOut = () => sessionStorage.removeItem(LOGGED_OUT_KEY)
